import { Brands } from "./brands.entity";
import { EntityRepository, Repository } from "typeorm";

@EntityRepository(Brands)
export class BrandsRepository extends Repository<Brands> {

}